function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import RelateComputer from './RelateComputer';
import GeometryGraphOperation from '../GeometryGraphOperation';
import RectangleContains from '../predicate/RectangleContains';
import RectangleIntersects from '../predicate/RectangleIntersects';
var RelateOp = /*#__PURE__*/function (_GeometryGraphOperati) {
  function RelateOp() {
    var _this;
    _classCallCheck(this, RelateOp);
    _this = _callSuper(this, RelateOp);
    RelateOp.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(RelateOp, _GeometryGraphOperati);
  return _createClass(RelateOp, [{
    key: "getIntersectionMatrix",
    value: function getIntersectionMatrix() {
      return this._relate.computeIM();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RelateOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "covers",
    value: function covers(g1, g2) {
      if (g2.getDimension() === 2 && g1.getDimension() < 2) {
        return false;
      }
      if (g2.getDimension() === 1 && g1.getDimension() < 1 && g2.getLength() > 0.0) {
        return false;
      }
      if (!g1.getEnvelopeInternal().covers(g2.getEnvelopeInternal())) return false;
      if (g1.isRectangle()) {
        return true;
      }
      return new RelateOp(g1, g2).getIntersectionMatrix().isCovers();
    }
  }, {
    key: "intersects",
    value: function intersects(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      if (g1.isRectangle()) {
        return RectangleIntersects.intersects(g1, g2);
      }
      if (g2.isRectangle()) {
        return RectangleIntersects.intersects(g2, g1);
      }
      if (g1.isGeometryCollection() || g2.isGeometryCollection()) {
        var r = false;
        for (var i = 0; i < g1.getNumGeometries(); i++) {
          for (var j = 0; j < g2.getNumGeometries(); j++) {
            if (g1.getGeometryN(i).intersects(g2.getGeometryN(j))) {
              return true;
            }
          }
        }
        return false;
      }
      return new RelateOp(g1, g2).getIntersectionMatrix().isIntersects();
    }
  }, {
    key: "touches",
    value: function touches(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      return new RelateOp(g1, g2).getIntersectionMatrix().isTouches(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "equalsTopo",
    value: function equalsTopo(g1, g2) {
      if (!g1.getEnvelopeInternal().equals(g2.getEnvelopeInternal())) return false;
      return RelateOp.relate(g1, g2).isEquals(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "relate",
    value: function relate() {
      if (arguments.length === 2) {
        var a = arguments[0];
        var b = arguments[1];
        var relOp = new RelateOp(a, b);
        var im = relOp.getIntersectionMatrix();
        return im;
      } else if (arguments.length === 3) {
        var _a = arguments[0];
        var _b = arguments[1];
        var boundaryNodeRule = arguments[2];
        var _relOp = new RelateOp(_a, _b, boundaryNodeRule);
        var _im = _relOp.getIntersectionMatrix();
        return _im;
      }
    }
  }, {
    key: "overlaps",
    value: function overlaps(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      return new RelateOp(g1, g2).getIntersectionMatrix().isOverlaps(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "crosses",
    value: function crosses(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      return new RelateOp(g1, g2).getIntersectionMatrix().isCrosses(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "contains",
    value: function contains(g1, g2) {
      if (g2.getDimension() === 2 && g1.getDimension() < 2) {
        return false;
      }
      if (g2.getDimension() === 1 && g1.getDimension() < 1 && g2.getLength() > 0.0) {
        return false;
      }
      if (!g1.getEnvelopeInternal().contains(g2.getEnvelopeInternal())) return false;
      if (g1.isRectangle()) {
        return RectangleContains.contains(g1, g2);
      }
      return new RelateOp(g1, g2).getIntersectionMatrix().isContains();
    }
  }]);
}(GeometryGraphOperation);
export { RelateOp as default };
RelateOp.constructor_ = function () {
  this._relate = null;
  if (arguments.length === 2) {
    var g0 = arguments[0];
    var g1 = arguments[1];
    GeometryGraphOperation.constructor_.call(this, g0, g1);
    this._relate = new RelateComputer(this._arg);
  } else if (arguments.length === 3) {
    var _g = arguments[0];
    var _g2 = arguments[1];
    var boundaryNodeRule = arguments[2];
    GeometryGraphOperation.constructor_.call(this, _g, _g2, boundaryNodeRule);
    this._relate = new RelateComputer(this._arg);
  }
};